import { useEffect } from 'react';
import { useProductContext } from '../../../context/ProductContext';
import { useShopContext } from '../../../context/ShopContext';
import { BranchProductAssignInput } from '../../../types';
import AddProductButton from './AddProductButton';
import ProductTable from './ProductTable';
import GenericModal from '../../../components/utils/GenericModal';
import { useGenericModal } from '../../../context/GenericModalContext';
import ProductForm from './ProductForm';

export default function ProductsTab() {
  const {
    products,
    fetchProducts,
    createProduct,
    assignProductToBranch,
    categories,
    fetchCategories,
    loading,
    error,
  } = useProductContext();
  const { adminBranches,fetchAdminBranches } = useShopContext();
  const { openModal, closeModal } = useGenericModal();

  useEffect(() => {
    fetchProducts();
    fetchCategories();
    fetchAdminBranches()
  }, []);

  const handleAddProduct = () => {
    // console.log('admin cart ');
    
    fetchAdminBranches()

    openModal(
        "إضافة منتج جديد",            // ✅ title

      <ProductForm
        categories={categories}
        branches={adminBranches}
        onSubmit={handleFormSubmit}
        onCancel={closeModal}
      />
    );
  };

  const handleFormSubmit = async (productData: FormData, assignData: BranchProductAssignInput) => {
    const newProduct = await createProduct(productData);
    assignData.product_id = newProduct.id;
    await assignProductToBranch(assignData);
    await fetchProducts();
    closeModal();
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Products</h2>
        <AddProductButton onClick={handleAddProduct} />
      </div>
      <ProductTable products={products} isLoading={loading} error={error} />
      <GenericModal />
    </div>
  );
}
